var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// OrderNew shows OrderForm and OrderReview
import React, { Component } from "react";
import AgentForm from "./AgentForm";
import AgentReview from "./AgentReview";
var AgentNew = /** @class */ (function (_super) {
    __extends(AgentNew, _super);
    function AgentNew() {
        // same as state = { formReview: false };
        // constructor(props) {
        //   super(props);
        //
        //   this.state = {formReview: false}
        // }
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { showFormReview: false };
        return _this;
    }
    AgentNew.prototype.renderContent = function () {
        var _this = this;
        if (this.state.showFormReview) {
            return (React.createElement(AgentReview, { user: this.state.user, send: this.props.send, enterprises: this.props.enterprises, onCancel: function () { return _this.setState({ showFormReview: false }); } }));
        }
        return (React.createElement(AgentForm, { currentUser: this.props.currentUser, enterprises: this.props.enterprises, lastUser: this.state.user, checkUser: function (user) { return _this.setState({ showFormReview: true, user: user }); } }));
    };
    AgentNew.prototype.render = function () {
        return React.createElement("div", { className: "container" }, this.renderContent());
    };
    return AgentNew;
}(Component));
export default AgentNew;



//////////////////
// WEBPACK FOOTER
// ./src/components/users/AgentNew.tsx
// module id = 1223
// module chunks = 0